// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_feff07dc","icon":"_5a8bc44f","hasUnread":"_e3cf56d7"};